import { useEffect } from 'react';
import { useQuery } from '@apollo/client/react';

import {
    ISkillCertificatesQueryVariables,
    SkillCertificatesDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

interface IUseSkillCertificateListOptions {
    queryVariables: ISkillCertificatesQueryVariables;
    skip?: boolean;
}

export const useSkillCertificateList = ({
    queryVariables,
    skip = false,
}: IUseSkillCertificateListOptions) => {
    const { showApolloError } = useApolloError();

    const { loading, data, refetch, error } = useQuery(
        SkillCertificatesDocument,
        {
            variables: queryVariables,
            skip,
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const items = data?.skillPortfolioReport || [];

    return {
        items,
        loading,
        refetch,
    };
};
